import React, { useEffect, useMemo, useRef, useState } from "react";
import "./Athletes.scss";
import one from './imgAthletes/1.jpg';
import two from './imgAthletes/2.jpg';
import three from './imgAthletes/3.jpg';
import four from './imgAthletes/4.jpg';
import five from './imgAthletes/5.jpg';
import six from './imgAthletes/6.jpg';
import seven from './imgAthletes/7.jpg';
import eight from './imgAthletes/8.jpg';
import nine from './imgAthletes/9.jpg';
import ten from './imgAthletes/10.jpg';
import eleven from './imgAthletes/11.jpg';
import twelve from './imgAthletes/12.jpg';
import thirteen from './imgAthletes/13.jpg';
import fourteen from './imgAthletes/14.jpg';
import fifteen from './imgAthletes/15.jpg';
import sixteen from './imgAthletes/16.jpg';
import seventeen from './imgAthletes/17.jpg';
import eighteen from './imgAthletes/18.jpg';
import nineteen from './imgAthletes/19.jpg';
import twenty from './imgAthletes/20.jpg';
import twentyone from './imgAthletes/21.jpg';
import twentytwo from './imgAthletes/22.jpg';
import twentythree from './imgAthletes/23.jpg';


const defaultPhotos = [
  { src: one, alt: "Top Ring athlete 1", title: "Top Ring 1", pos:'center 20%' },
  { src: two, alt: "Top Ring athlete 2", title: "Top Ring 2", pos:'center 30%'},
  { src: three, alt: "Top Ring athlete 3", title: "Top Ring 3" },
  { src: four, alt: "Top Ring athlete 4", title: "Top Ring 4", pos:'center 30%' },
  { src: five, alt: "Top Ring athlete 5", title: "Top Ring 5" },
  { src: six, alt: "Top Ring athlete 6", title: "Top Ring 6", pos:'center 30%' },
  { src: seven, alt: "Top Ring athlete 7", title: "Top Ring 7", pos:'center 30%' },
  { src: eight, alt: "Top Ring athlete 8", title: "Top Ring 8", pos:'center 40%' },
  { src: nine, alt: "Top Ring athlete 9", title: "Top Ring 9", pos:'center 30%' },
  { src: ten, alt: "Top Ring athlete 10", title: "Top Ring 10" },
  { src: eleven, alt: "Top Ring athlete 11", title: "Top Ring 11" },
  { src: twelve, alt: "Top Ring athlete 12", title: "Top Ring 12", pos:'center 30%' },
  { src: thirteen, alt: "Top Ring athlete 13", title: "Top Ring 13", pos:'center 40%' },
  { src: fourteen, alt: "Top Ring athlete 14", title: "Top Ring 14", pos:'center 30%' },
  { src: fifteen, alt: "Top Ring athlete 15", title: "Top Ring 15" },
  { src: sixteen, alt: "Top Ring athlete 16", title: "Top Ring 16" },
  { src: seventeen, alt: "Top Ring athlete 17", title: "Top Ring 17" },
  { src: eighteen, alt: "Top Ring athlete 18", title: "Top Ring 18", pos:'center 30%' },
  { src: nineteen, alt: "Top Ring athlete 19", title: "Top Ring 19" },
  { src: twenty, alt: "Top Ring athlete 20", title: "Top Ring 20" },
  { src: twentyone, alt: "Top Ring athlete 21", title: "Top Ring 21" },
  { src: twentytwo, alt: "Top Ring athlete 22", title: "Top Ring 22", pos:'center 40%' },
  { src: twentythree, alt: "Top Ring athlete 23", title: "Top Ring 23" },
];


function getSlidesPerView(width) {
  if (width <= 560) return 1;
  if (width <= 980) return 2;
  return 3;
}

export default function Athletes({ photos, autoMs = 10000 }) {
  const items = useMemo(() => (photos?.length ? photos : defaultPhotos), [photos]);

  const [slidesPerView, setSlidesPerView] = useState(() =>
    typeof window !== "undefined" ? getSlidesPerView(window.innerWidth) : 3
  );
  const [index, setIndex] = useState(0);

  const trackRef = useRef(null);
  const timerRef = useRef(null);
  const pauseRef = useRef(false);

  // Resize -> slidesPerView
  useEffect(() => {
    const onResize = () => setSlidesPerView(getSlidesPerView(window.innerWidth));
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const maxIndex = Math.max(0, items.length - slidesPerView);

  // Clamp index when slidesPerView changes
  useEffect(() => {
    setIndex((prev) => Math.min(prev, maxIndex));
  }, [maxIndex]);

  const goTo = (i) => setIndex(() => Math.max(0, Math.min(i, maxIndex)));
  const next = () => setIndex((i) => (i >= maxIndex ? 0 : i + 1));
  const prev = () => setIndex((i) => (i <= 0 ? maxIndex : i - 1));

  const resetTimer = () => {
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      if (!pauseRef.current) next();
    }, autoMs);
  };

  useEffect(() => {
    resetTimer();
    return () => timerRef.current && clearInterval(timerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoMs, maxIndex]);

  // Pause on hover/focus (desktop)
  const onMouseEnter = () => (pauseRef.current = true);
  const onMouseLeave = () => (pauseRef.current = false);

  // Swipe (mobile)
  const touch = useRef({ x: 0, y: 0, active: false });

  const onTouchStart = (e) => {
    const t = e.touches[0];
    touch.current = { x: t.clientX, y: t.clientY, active: true };
    pauseRef.current = true;
  };

  const onTouchEnd = (e) => {
    if (!touch.current.active) return;
    const t = e.changedTouches[0];
    const dx = t.clientX - touch.current.x;
    const dy = t.clientY - touch.current.y;
    touch.current.active = false;

    // Если свайп больше по горизонтали
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
      if (dx < 0) next();
      else prev();
      resetTimer();
    }

    pauseRef.current = false;
  };

  const pages = maxIndex + 1;

  return (
    <section className="athletes" id="athletes">
      <div className="athletes__container">
        <div className="athletes__head">
          <h2 className="athletes__title">Mūsu sportisti — mūsu lepnums</h2>
          <p className="athletes__subtitle">
            Latvijas izlases sportisti, čempioni un topošie līderi.
          </p>
        </div>

        <div
          className="athletes__slider"
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <button
            className="athletes__arrow athletes__arrow--left"
            type="button"
            onClick={() => {
              prev();
              resetTimer();
            }}
            aria-label="Previous"
          >
            ‹
          </button>

          <div
            className="athletes__viewport"
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
          >
            <div
              ref={trackRef}
              className="athletes__track"
              style={{
                transform: `translateX(-${(index * 100) / slidesPerView}%)`,
              }}
            >
              {items.map((p, i) => (
                <div
                  key={`${p.src}-${i}`}
                  className="athletes__slide"
                  style={{ width: `${100 / slidesPerView}%` }}
                >
                  <div className="athletes__card">
                    <img
                      className="athletes__img"
                      src={p.src}
                      alt={p.alt || "Athlete"}
                      loading="lazy"
                      style={{ objectPosition: p.pos || 'center 20%' }}
                    />
                    <div className="athletes__overlay">
                      <span className="athletes__tag">{p.title || "Top Ring"}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button
            className="athletes__arrow athletes__arrow--right"
            type="button"
            onClick={() => {
              next();
              resetTimer();
            }}
            aria-label="Next"
          >
            ›
          </button>
        </div>

        {pages > 1 && (
          <div className="athletes__dots" aria-label="Slider pagination">
            {Array.from({ length: pages }).map((_, p) => (
              <button
                key={p}
                type="button"
                className={`athletes__dot ${p === index ? "is-active" : ""}`}
                onClick={() => {
                  goTo(p);
                  resetTimer();
                }}
                aria-label={`Go to slide ${p + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
